module.exports = __webpack_public_path__ + "static/media/logo-black.36474486.svg";